// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"300":"65c65cdd","659":"a76844c3"}[chunkId] + ".js";
};